import Component from '../inherited/Component'

export default class FixtuurElem extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount () {
    Fixtuur("attachMethod", {
        selector: this._options.elem,
        method: "startExplorer",
        data: {
            productId: this._options.id
        }
    })
  }
}